/* eslint-disable no-unused-vars */
/* global G */
import { curry } from 'lib/util'
import sequenceComponentFindProxy from 'lib/sequence/component/children/find'
import { set } from 'lib/sequence/component/state/value'
import { actionWithHooks } from 'lib/sequence/module/action'

/**
 * Get Clipboard And Persist Change And Action Event Handler
 *
 * Tries to set the value of `content` from the clipboard if possible.
 * If not, it'll show a notification.
 *
 * @param {Gaia.AppModule.Spec} module    current module
 * @param {Gaia.Component.Spec} component component that triggered the event
 * @param {Gaia.PlatformEvent} event      the event object
 * @returns {Promise<void>}
 */
const getClipboardAndPersistChangeAndAction = async (module, component, event) => {
  const clipboardAdapter = module[G.ADAPTER][G.CLIPBOARD]
  const eventBus = module[G.ADAPTER][G.EVENTS]

  try {
    if (await clipboardAdapter.hasText()) {
      const clipboard = await clipboardAdapter.getText()
      const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
      const { content } = sequenceComponentFindProxy(actionComponent)

      set(content, clipboard)
      await actionWithHooks(module[G.STATE][G.ACTION])([])
    } else {
      eventBus.dispatch(eventBus.type(G.DATA, G.UPDATE), {
        message: await module[G.ADAPTER][G.INTL]._t('data.clipboard.noText', {
          ns: 'common',
          _key: 'data.clipboard.noText',
          defaultValue: 'Could not paste from clipboard because its content is not text',
        }),
        severity: 'warning',
        variant: 'filled',
        duration: 5000,
      })
    }
  } catch (e) {
    console.error(e)
  }
}

export default curry(getClipboardAndPersistChangeAndAction)
